<template>
	<b-navbar toggleable="lg" type="dark" class="menu row" :class="{ 'is-scrolled': scrolled }" fixed="top">
		<a id="top" />
		<b-container>
			<router-link class="w-link logo no-router-link-active" to="/">
				<img src="@/assets/MGLogo.png" alt="Money Guided" height="25">
			</router-link>
			<router-link class="w-link no-router-link-active brand-link" to="/"><b-navbar-brand>Money Guided</b-navbar-brand></router-link>
			<!-- The sign up flow drops the nav to a logo and a Contact us pill: nothing
				should invite the member out of the flow. -->
			<button v-if="bare" class="mg-btn mg-nav-cta bare-cta" v-b-modal.contact-modal>
				Contact us
			</button>

			<b-navbar-toggle v-if="!bare" target="nav-collapse"></b-navbar-toggle>
			<b-collapse v-if="!bare" id="nav-collapse" is-nav>
				<b-navbar-nav class="menu-center">
					<b-nav-item class="w-link" to="/employers">Employers</b-nav-item>
					<b-nav-item class="w-link" to="/features">Features</b-nav-item>
					<b-nav-item class="w-link" to="/guide">Blogs</b-nav-item>
					<b-nav-item class="w-link" to="/about">About</b-nav-item>
					<b-nav-item class="w-link" to="/faq">FAQ's</b-nav-item>
					<b-nav-item class="w-link" to="/signup">Sign up</b-nav-item>
				</b-navbar-nav>
				<b-navbar-nav class="menu-right">
					<li class="nav-item">
						<button class="mg-btn mg-nav-cta" v-b-modal.contact-modal>
							Contact Us
						</button>
					</li>
				</b-navbar-nav>
			</b-collapse>
		</b-container>
	</b-navbar>
</template>

<script>
export default {
	props: {
		menuMode: String
	},
	data() {
		return { scrolled: false };
	},
	computed: {
		// meta.api is set on exactly the sign up routes (/signup, /signup/callback and the
		// employer landings), which are the ones Figma gives the stripped back nav.
		bare() {
			return Boolean(this.$route.meta && this.$route.meta.api);
		},
	},
	mounted() {
		this.onScroll();
		window.addEventListener('scroll', this.onScroll, { passive: true });
	},
	beforeDestroy() {
		window.removeEventListener('scroll', this.onScroll);
	},
	methods: {
		onScroll() {
			this.scrolled = window.scrollY > 24;
		},
		menuEvent(mode) {
			this.menuMode = mode;
			this.$emit('menuEvent', mode);
		}
	}
}
</script>

<style scoped>
.menu {
	background-color: rgba(26, 18, 48, 0.8) !important;
	backdrop-filter: blur(18px) saturate(140%);
	-webkit-backdrop-filter: blur(18px) saturate(140%);
	min-height: 64px;
	padding-top: 14px;
	padding-bottom: 14px;
	box-shadow: 0 10px 40px rgba(26, 18, 48, 0.15);
	border-bottom: 1px solid rgba(255, 255, 255, 0.06);
	transition: background-color 350ms var(--ease-out, ease), box-shadow 350ms var(--ease-out, ease), border-color 350ms var(--ease-out, ease), padding 350ms var(--ease-out, ease);
}

.menu.is-scrolled {
	background-color: rgba(26, 18, 48, 0.78) !important;
	box-shadow: 0 12px 44px rgba(26, 18, 48, 0.35);
	border-bottom-color: rgba(255, 255, 255, 0.1);
	padding-top: 8px;
	padding-bottom: 8px;
}

.menu >>> .container {
	margin-left: 10px;
	margin-right: 10px;
	max-width: 100%;
}

.menu img {
	margin-right: 10px;
	transition: transform 300ms var(--ease-out, ease);
}
.logo:hover img { transform: rotate(-6deg) scale(1.05); }
.logo { margin-right: 10px !important; border-bottom: none !important; }

.brand-link, .brand-link:hover { border-bottom: none !important; text-decoration: none; }
.navbar-brand {
	font-size: 14px !important;
	font-weight: 700;
	letter-spacing: 0.01em;
	color: #fff !important;
}

.menu-center { margin-left: auto; margin-right: auto; gap: 4px; }

.w-link, .w-link:hover, .w-link:active {
	color: rgba(255, 255, 255, 0.85) !important;
	text-decoration: none;
	margin-right: 4px;
	font-size: 13px;
	font-weight: 600;
	letter-spacing: 0.01em;
	padding: 0;
	position: relative;
	transition: color 200ms var(--ease-out, ease);
}
.w-link:hover { color: #fff !important; }

.w-link >>> .nav-link {
	padding: 8px 16px !important;
	position: relative;
	border-radius: 999px;
	/* Override Bootstrap's navbar-dark 50% white, which fails WCAG AA */
	color: rgba(255, 255, 255, 0.92) !important;
	transition: background 220ms var(--ease-out, ease), color 220ms var(--ease-out, ease);
}
.w-link >>> .nav-link:hover { color: #fff !important; }
.w-link >>> .nav-link:hover {
	background: rgba(255, 255, 255, 0.06);
}

/* Animated peach pill underline on active route */
.w-link >>> .nav-link::after {
	content: '';
	position: absolute;
	left: 50%;
	bottom: -2px;
	width: 0;
	height: 3px;
	background: var(--mg-grad-peach-strong, linear-gradient(135deg, #F4B89A, #E89B79));
	border-radius: 999px;
	transform: translateX(-50%);
	transition: width 320ms var(--ease-out, ease), opacity 220ms var(--ease-out, ease);
	opacity: 0;
}
.w-link >>> .nav-link.router-link-active::after {
	width: 24px;
	opacity: 1;
}
.w-link >>> .nav-link.router-link-active {
	color: #fff !important;
	background: rgba(255, 255, 255, 0.08);
}

/* Kill old underline border style from global rules */
.router-link-active { border-bottom: none !important; }
.no-router-link-active { border-bottom: none !important; }

/* Compact navbar sizing for the shared .mg-btn primary style */
.mg-nav-cta {
	gap: 8px;
	height: 40px;
	padding: 0 18px;
	font-size: 13px;
	color: var(--mg-ink) !important;
	background: var(--mg-grad-peach-strong);
	box-shadow: 0 8px 24px rgba(244, 184, 154, 0.35);
}
.mg-nav-cta:hover {
	transform: translateY(-2px);
	box-shadow: 0 14px 36px rgba(244, 184, 154, 0.5);
}
.mg-nav-cta:focus-visible { outline: none; box-shadow: 0 0 0 3px rgba(244, 184, 154, 0.35); }

/* Figma's sign up nav: a plain white pill pushed to the right edge */
.bare-cta {
	margin-left: auto;
	background: var(--mg-white);
	box-shadow: none;
}
.bare-cta:hover {
	background: var(--mg-white);
	box-shadow: 0 10px 28px rgba(26, 18, 48, 0.25);
}

.btn:focus, .btn.focus { box-shadow: none !important; }

@media all and (max-width: 991px) {
	.menu {
		background-color: rgba(26, 18, 48, 0.85) !important;
		backdrop-filter: blur(18px) saturate(140%);
		-webkit-backdrop-filter: blur(18px) saturate(140%);
	}
	.menu img { margin-right: 16px; margin-left: 10px; }
	.w-link >>> .nav-link {
		text-align: center;
		margin: 4px auto;
	}
	.menu-right { justify-content: center; margin-top: 12px; }
	.navbar-toggler {
		border: 0 !important;
		color: white !important;
	}
	.w-link >>> .nav-link.router-link-active::after { display: none; }
}

@media (prefers-reduced-motion: reduce) {
	.menu, .mg-nav-cta, .w-link, .w-link >>> .nav-link {
		transition: none !important;
	}
}
</style>
